/**
 * API Endpoints Constants
 *
 * Centralized location for API endpoint URLs to avoid hardcoded strings.
 */

export const CLINICAL_TRIAL_ENDPOINTS = {
    /** Fetch trial data from ClinicalTrials.gov by NCT ID */
    FETCH_TRIAL: (nctId: string) => `clinical-trial/${nctId}` as const,
    /** Parse eligibility text using LLM */
    PARSE_ELIGIBILITY: 'clinical-trial/parse' as const,
    /** Execute patient queries with SSE streaming */
    EXECUTE_STREAM: '/api/clinical-trial/execute-stream' as const,
} as const;
